import HttpMethod from './httpMethods'
import axios, { AxiosResponse } from 'axios';
import { ApiResponse } from './types';

//ImportExcel

export async function postImportActivityDataExcelAPI(file:File,id:string): Promise<ApiResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return await makeRequest(HttpMethod.POST, '/api/activitydata/excel?idEstablisment='+id, formData)
}

//End import excel

//Repository
export async function getRepositoriesAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/activitydata/repository/'+value, {})
}
export async function postRepositoriesAPI(month:string,id:string,file:File): Promise<ApiResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return await makeRequest(HttpMethod.POST, '/api/activitydata/repository/upload/'+month+"/"+id, formData)
}

export async function deleteRepositoriesAPI(value:string,value2:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/activitydata/repository/upload/'+value+"/"+value2, {})
}
export async function getPDFRepositoriesAPI(value:string,activityDataId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/activitydata/repository/view/'+value+"/"+activityDataId, {})
}
//End Repository

//Results
export async function getPortafolioGeiYearsByOrganizationIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/results/portafolio/years/'+value, {})
}
export async function getGeiYearsByOrganizationIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/results/years/'+value, {})
}
export async function getCategoriesByOrganizationIdAndYearAPI(value:string,year:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/results/organization/years/'+value+"/"+year, {})
}

export async function getCategoriesByOrganizationUnifiedIdAndYearAPI(value:string,year:string,typeResult:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/results/organization/unified/years/'+value+"/"+year+"?typeResult="+typeResult, {})
}

//End Results


//PCG_Emissions
export async function postResgisterPcgEmissionsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/pcg/emission', value)
}
export async function deletePcgEmissionsAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/pcg/emission/'+value, {})
}
export async function getPcgEmissionsAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/pcg/emission/'+value, {})
}
//End PCG_Emissions
//pcg

export async function getAllPcgAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/pcg', {})
}
export async function GetPcgByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/pcg/id/'+value, {})
}
export async function postRegisterPcgAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/pcg', value)
}
export async function putUpdatePcgAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/pcg', value)
}

//EndPcg
//TransformationFactors
export async function getAllTransformationAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transformation', {})
}
export async function GetTransformationByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transformation/id/'+value, {})
}
export async function GetTransformationByFilterFlowAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transformation/flow?filter='+value, {})
}
export async function postRegisterTransformationAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/transformation', value)
}
export async function putUpdateTransformationAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/transformation', value)
}
export async function getTransformationFactorsUnitByEmissionorganizationIdAPI(value:string,emissionOrganizationId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transformation/unit/'+value+"/"+emissionOrganizationId, {})
}
export async function getTransformationFactorsUnitByEmissionIdAPI(value:string,emissionId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transformation/unit/emission/'+value+"/"+emissionId, {})
}

export async function getTransformationFactorsUnitByFlowAndSourceAPI(value:string,source:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transformation/flow/chart?flow='+value+"&source="+source, {})
}

export async function getTransformationFactorsUnitByEmissionSourceIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transformation/'+value, {})
}


//EndTransformationFactors


//ActivityData
export async function getAllActivityByEstablishmentAPI(value:String): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/activitydata/establishment/'+value, {})
}
export async function GetActivityByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/activitydata/id/'+value, {})
}
export async function postRegisterActivityAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/activitydata', value)
}
export async function putUpdateActivityAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/activitydata', value)
}
export async function deleteActivityDataByIdAPI(value:String): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/activitydata?id='+value, {})
}
export async function getTransformationFactorsActivityByActivityIdAPI(value:String): Promise<ApiResponse>{
    return await makeRequest(HttpMethod.GET, '/api/activitydata/transformationFactors/'+ value, {})
}

//EndActivityData

//Emissions_organizations
export async function postResgisterEmissionsOrganizationAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/emissionsource/organization', value)
}
export async function deleteEmissionsOrganizationAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/emissionsource/organization/'+value, {})
}
export async function getEmissionsOrganizationAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/organization/'+value, {})
}
//End Emissions_Organizations

//Emissions
export async function getAllEmissionsTableAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/emissionsource', {})
}
export async function getEmissionsByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/id/'+value, {})
}
export async function postResgisterEmissionsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/emissionsource', value)
}
export async function putResgisterEmissionsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/emissionsource', value)
}

export async function postRegisterTypeEventAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/emissionsource/typeevent', value)
}
export async function putUpdatesTypeEventAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/emissionsource/typeevent', value)
}

export async function getTypeEventAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/typeevent', {})
}

export async function postRegisterEmissionSourcesTypeEventAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/emissionsource/emissiontypeevent', value)
}
export async function deleteRegisterEmissionSourcesTypeEventAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/emissionsource/emissiontypeevent?emissionSourcesTypeEventId='+value, {})
}
export async function GetAllTypeEventByEmissionAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/emissiontypeevent?emissionId='+value, value)
}







//End Emissions

//Category
export async function getAllCategoryTableAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/category', {})
}
export async function postResgisterCategoryAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/category', value)
}
export async function putResgisterCategoryAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/category', value)
}
export async function getCategoryByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/category/id/'+value, {})
}
//EndCategory


//Establishment

export async function GetEstablishmentGeiInventoryByIdAPI(id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geiinventory/establishmentGeiInventory?id='+id, {})
}

export async function DeleteEstablishmentGeiInventoryByIdAPI(id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/establishment/gei?id='+id, {})
}

export async function PostEstablismentGeiAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/establishment/gei', value)
}
export async function GetSelectableEstablishmentGeiInventoryByOrganizationIdAPI(organizationId:string,geiId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/establishment/select?organizationId='+organizationId+"&geiInventoryId="+geiId, {})
}
export async function getAllGeiEstablishmentAPI(page:number, pageSize:number,geiId:string,organizationId:string,filter:string,orderby:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/establishment/gei?page='+page+"&pageSize="+pageSize+"&geiId="+geiId+"&organizationId="+organizationId+"&filter="+filter+"&orderby="+orderby, {})
}

export async function getAllEstablishmentTableAPI(page:number, pageSize:number,filter:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/establishment/'+page+"/"+pageSize+"?filter="+filter, {})
}

export async function getAllEstablishmentTableByOrganizationAPI(page:number, pageSize:number,id:string,filter:string,orderYear:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/establishment/organization/'+page+"/"+pageSize+"/"+id+"/"+filter+"?order="+orderYear, {})
}

export async function getAllEstablishmentTableByUserAPI(page:number, pageSize:number,filter:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/establishment/user/'+page+"/"+pageSize+"?filter="+filter, {})
}
export async function postResgisterEstablishmentAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/establishment', value)
}
export async function putResgisterEstablishmentAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/establishment', value)
}
export async function getEstablishmentByCodeAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/establishment/validate/'+value, {})
}
export async function putActiveEstablishmentAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/establishment/active', value)
}
export async function deleteEstablishmentByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/establishment/'+value, {})
}
export async function getEstablishmentByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/establishment/id/'+value, {})
}
export async function deleteEstablishmentMethodByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/establishment?id='+value, {})
}

//End Establishment

//GeiInventory
export async function postResgisterGeiInventoryAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/geiinventory', value)
}
export async function getAllGeiInventoryFilterAPI(filter:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geiinventory/filter/'+filter, {})
}
export async function getAllGeiInventoryTableAPI(page:number, pageSize:number,filter:string,order:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geiinventory/'+page+"/"+pageSize+"?filter="+filter+"&order="+order, {})
}
export async function putResgisterGeiInventoryAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/geiinventory', value)
}
export async function getGeiInventoryByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geiinventory/id/'+value, {})
}
export async function getAlLGeiInventoryTableByUserAPI(page:number, pageSize:number,filter:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geiinventory/user/'+page+"/"+pageSize+"?filter="+filter, {})
}
export async function deleteGeiInventoryByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/geiinventory?id='+value, {})
}
export async function getAllEstablishmentByGeiInventoryIdAPI(page:number, pageSize:number,id:string,filter:string,orderYear:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geiinventory/establishmentGeiInventory/'+page+"/"+pageSize+"/"+id+"/?filter="+filter+"&orderby="+orderYear, {})
}
export async function postRegisterestablishmentGeiInventoryAPI(value: Object): Promise<ApiResponse>{
    return await makeRequest(HttpMethod.POST,'/api/geiinventory/establishmentGeiInventory', value)
}
//EndGeiInventory

//GeiEvents
export async function postRegisterGeiEventAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/geievent/event', value)
}
export async function putRegisterGeiEventAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/geievent/event', value)
}
export async function putActivoGeiEventAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/geievent/event/inactive', value)
}
export async function putRegisterStatusGeiEventAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/geievent/event/status', value)
}
export async function getGeiEventByIdAPI(page:number, pageSize:number,id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geievent/event?organizationId='+id+'&page='+page+'&pageSize='+pageSize, {})
}
export async function getGeiEventScheduleByEventIdAPI(id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geievent/schedule?id='+id, {})
}
export async function getGeiEventActivityByScheduleIdAPI(id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/geievent/eventactivitydata?id='+id, {})
}
export async function putGeiActivityEventAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/geievent/eventactivitydata', value)
}
export async function deleteGeiEventActivityByIdAPI(value: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/geievent/eventactivitydata?id='+value, {})
}
export async function postGeiEventActivityAPI(value : Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/geievent/eventactivitydata', value)
}
export async function getGeiEventResultsAPI(id:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/results/event?id='+id, {})
}
export async function getEmissionsByTypeIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/typeevent/'+ value, {})
}
export async function putScheduleGeiEventAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/geievent/schedule', value)
}

//EndGeiEvents  /api/geievent/eventactivitydata

//User
export async function postOrganizationsUserAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/organization', value)
}
export async function deleteOrganizationsUserAPI(value: string, value2 : string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/user/organization?OrganizationId='+value+'&UserId='+value2, {})
}
export async function getOrganizationsUserAPI(value: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/user/organization?userId='+value, {})
}
export async function postLoginUserAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/login', value)
}
export async function postResgisterUserAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/register', value)
}
export async function putUpdatePasswordAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/user/password', value)
}
export async function putUpdateAdminPasswordAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/user/admin/password', value)
}
export async function putResetPasswordAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/user/reset/password', value)
}
export async function putActiveUserAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/user/active', value)
}
export async function putUpdateUserAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/user', value)
}
export async function deleteInactiveUserAPI(value: String): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/user/'+value, {})
}
export async function getValidateUserAPI(email: String): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/user/validate/'+email, {})
}
export async function getUserByTokenAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/user/token', {})
}
export async function getAllUsersTableAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/user', {})
}
export async function getUserByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/user/id/'+value, {})
}
export async function getAllActiveGroupAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/user/group', {})
}
export async function deleteUserByIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/user?id='+value, {})
}

export async function getAllModuleTokenWithUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/moduletoken', value)
}
//End user




export async function makeRequest(method: string, url: string, object: Object): Promise<ApiResponse> {
    let response: AxiosResponse<any>;
    try {
        switch (method) {
            case HttpMethod.GET:
                response = await axios.get(url, object)
                break;
            case HttpMethod.POST:
                response = await axios.post(url, object)
                break;
            case HttpMethod.PUT:
                response = await axios.put(url, object)
                break;
            case HttpMethod.DELETE:
                response = await axios.delete(url, object)
                break;
            default:
                throw new Error('Invalid Method')
        }
        return {
            StatusCode: response.status,
            Response: response.data,
            Error: null
        }
    } catch (error:any) {
        return {
            StatusCode: error.response.status,
            Response: null,
            Error: error.response.data
        }
    }
}